import clsx from "~/util/html/style";

export function Kbd(props: { class?: string; key: string; "aria-description"?: string }) {
  return (
    <kbd
      class={clsx(
        "inline-flex h-5 items-center justify-center rounded-md border border-brand-subtle bg-white font-mono text-2xs text-typography-tertiary shadow-[0px_1px_0px_0px_rgba(0,0,0,0.08)]",
        props.key.length === 1 ? "w-5" : "px-1",
        props.class,
      )}
      aria-description={props["aria-description"] ?? "keyboard shortcut"}
    >
      {props.key}
    </kbd>
  );
}
